<template>
  <div>
    <div id="foot" class="foot" @click="goLogin">
      <div class="foot-left">
        <!-- 立即开始私密聊天 -->
        下载后输入0000激活
      </div>
      <div class="foot-right">立即安装</div>
    </div>

    <!-- 复制的弹框 -->
    <div class="tan" :class="{tanhide:codeshow}">
      <div class="tan-head">
        <img :src="closeSrc" @click="closeTan" />
      </div>
      <div class="tan-page">
        <!-- <p>安卓版本：复制浏览器打开下载</p>
        <p>IOS版本：即将上线，敬请期待</p>-->
        <p class="tan-page-p">请复制到浏览器打开下载</p>
      </div>
      <div
        class="tan-foot"
        v-clipboard:copy="url"
        v-clipboard:success="copy"
        v-clipboard:error="onError"
      >
        <span>复制到浏览器打开</span>
      </div>
    </div>
    <div class="tan-back" @touchmove.prevent :class="{tanhide:codeshow}"></div>

    <!-- ios浏览器控制 -->
    <div class="tan" :class="{tanhide:iostan}">
      <div class="tan-head">
        <img :src="closeSrc" @click="iosColseTan" />
      </div>
      <div class="tan-page">
        <!-- <p>安卓版本版本正常使用</p>
        <p>IOS版本即将上线，敬请期待</p>-->
      </div>
      <div class="tan-foot" @click="iosColseTan">
        <span>我知道了</span>
      </div>
    </div>
    <div class="tan-back" @touchmove.prevent :class="{tanhide:iostan}"></div>

    <!--默认浏览器 -->
    <div class="tan" :class="{tanhide:iostande}">
      <div class="tan-head">
        <img :src="closeSrc" @click="iosColseTande" />
      </div>
      <div class="tan-page">
        <p>亲爱的用户，请您使用苹果"Safari浏览器"打开好运吧官网【www.haoyunba.com】进行下载，谢谢！</p>
      </div>
      <div
        class="tan-foot"
        v-clipboard:copy="url"
        v-clipboard:success="copy"
        v-clipboard:error="onError"
      >
        <span>复制网址</span>
      </div>
    </div>
    <div class="tan-back" @touchmove.prevent :class="{tanhide:iostande}"></div>
  </div>
</template>
<script>
import store from "../../store/index";
import util from "@/utils/util";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
import api from "../../api/index";
import tips from "@/estoast";

export default {
  name: "footH5",
  data() {
    return {
      codeshow: true,
      unimgSrc: require("../../assets/img/disagree@2x.png"),
      imgSrc: require("../../assets/img/agree.png"),
      closeSrc: require("../../assets/img/close@2x.png"),
      iostan: true,
      iostande: true,

      url: null
    };
  },
  mounted() {
    this.url = window.location.href;
  },
  methods: {
    copy(e) {
      console.log(e.text);
      tips.toast("复制成功，快去浏览器打开");
    },
    onError(e) {
      console.log(e);
      tips.toast("复制失败");
    },
    closeTan: function() {
      this.codeshow = true;
    },
    iosColseTan: function() {
      this.iostan = true;
    },
    iosColseTande: function() {
      this.iostande = true;
    },
    goLogin: function() {
      //this.$router.replace("/login");
      let ua = navigator.userAgent.toLowerCase();
      console.log("ua:" + JSON.stringify(ua));
      //Android终端
      let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1; //Ios终端
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isWeixinBrowser()) {
        //微信端
        //构造跳转的地址，并复制
        console.log("微信");
        this.codeshow = false;
      } else {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //Ios
          //tips.toast(" \n 即将上线，敬请期待");
          console.log("ios cid:" + store.state.mutations.channel);
          //非默认浏览器
          if (ua.indexOf("safari") > 0) {
            setTimeout(() => {
              this.$router.push("/iosSetting");
            }, 2000);

            var appurl =
              "itms-services:///?action=download-manifest&url=https://www.haoyunba.com/h5/ios/clac/manifest.plist";

            window.location.href = appurl;
          } else {
            this.iostande = false;
          }

          // window.location.href = 'https://apps.apple.com/cn/app/id1502944777';
          //使用企业签签名作为下载的标识

          // }
        } else {
          console.log("安卓");

          //Android终端
          window.location.href = "http://wap.haoyunba.com/apk/clac_android.apk";
          this.$point.eventId("down_app_100001");
        }
      }

      function isWeixinBrowser() {
        return /micromessenger/.test(ua) ? true : false;
      }
    }
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList"
    ])
  }
};
</script>
<style scoped>
.foot {
  position: absolute;
  left: 0;
  bottom: 0;
  box-sizing: border-box;
  height: 136px;
  width: 100%;
  background: rgba(248, 218, 190, 1);
}
.foot {
  box-sizing: border-box;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 998;
}

.foot-left {
  position: relative;
  width: 354px;
  height: 50px;
  font-size: 36px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(112, 44, 3, 1);
  line-height: 50px;
  float: left;
  margin: 44px 0 42px 44px;
}
.foot-right {
  position: relative;
  width: 234px;
  height: 80px;
  background: linear-gradient(90deg, #c92e2a 0%, #e34e7c 100%);
  border-radius: 10px;
  margin: 28px 50px 28px 0px;
  float: right;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 80px;
  margin: 30px 44px 18px 46px;
}
.foot-right button {
  width: 144px;
  height: 44px;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 44px;
  margin: 18px 44px 18px 46px;
}

.tan {
  position: fixed;
  z-index: 9999;
  top: 428px;
  margin: 0 auto;
  position: fixed;
  width: 540px;
  height: 370px;
  background: rgba(255, 255, 255, 1);
  border-radius: 16px;
  margin: 0px 104px 0px 106px;
  z-index: 99999;
}

.tan-back {
  position: fixed;
  z-index: 99998;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
}

.tan-head {
  width: 100%;
  height: 50px;
}
.tan-head img {
  position: relative;
  width: 32px;
  height: 32px;
  float: right;
  margin: 16px 20px 0 0;
}
.tan-page {
  width: 100%;
  height: 220px;
}
.tan-page-p {
  line-height: 220px;
}

.tan-foot {
  width: 540px;
  height: 102px;
  background: linear-gradient(
    90deg,
    rgba(108, 103, 253, 1) 0%,
    rgba(56, 48, 234, 1) 100%
  );
  border-radius: 0px 0px 16px 16px;
}

.tan-foot span {
  width: 240px;
  height: 50px;
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 100px;
}

.tan-page-text {
  width: 100%;
  height: 38px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 38px;
  padding: 20px 0 0 0;
}
.tan-page-code {
  width: 476px;
  height: 100px;
  padding: 22px 0 0 32px;
}
.tan-page-code div {
  float: left;
}

.tan-page-code-img {
  width: 190px;
  height: 92px;
  border-radius: 61px;
}

.tan-page-code-img img {
  width: 190px;
  height: 92px;
}

.tan-page-code-input {
  width: 272px;
  height: 92px;
  margin: 0 0 0 14px;
}
.tan-page-code-input input {
  width: 202px;
  height: 61px;
  background: rgba(247, 247, 247, 1);
  border-radius: 61px;
  border: none;
  padding: 15px 35px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(194, 194, 194, 1);
  line-height: 38px;
  text-align: center;
}

.tan-page-code-input input::-webkit-input-placeholder {
  position: relative;
  left: 20px;
  width: 172px;
  height: 38px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(194, 194, 194, 1);
  line-height: 38px;
  margin-left: -10px;
}
.tanhide {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/common/footAppinfo.vue